import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import type { UserInfo } from '@/app/types';
import { reportEvent } from '@/app/utils';

/**
 * Hook 用于设置 Sentry 用户信息
 * 当用户信息更新时，自动设置到 Sentry
 */
export const useSentryUser = (userInfo: UserInfo | null) => {
  useEffect(() => {
    if (userInfo) {
      // 设置用户信息到 Sentry
      Sentry.setUser({
        id: userInfo.id,
        subs_plan: userInfo.subs_plan,
        status: userInfo.status,
      });

      // 设置用户标签，方便在 Sentry 中筛选
      Sentry.setTag('user.subs_plan', userInfo.subs_plan);
      Sentry.setTag('user.status', userInfo.status);
    } else {
      // 用户登出时，清除 Sentry 用户信息
      Sentry.setUser(null);
      Sentry.setContext('user', null);
    }
  }, [userInfo]);
};

// 这些页面走自定义 page_name 上报（例如 stream_page / live_page），跳过 hook 的默认 pathname 上报，避免重复。
const CUSTOM_PAGE_VIEW_PATTERNS: RegExp[] = [/^\/(?:[^/]+\/)?vidu-stream(?:\/|$)/];

export const useReportPage = (pathname: string) => {
  useEffect(() => {
    if (CUSTOM_PAGE_VIEW_PATTERNS.some((pattern) => pattern.test(pathname))) {
      return;
    }
    reportEvent('page_view', {
      page_name: pathname,
      page_level: pathname.split('/').filter(Boolean).length,
    });
  }, [pathname]);
};
